import React, { useEffect } from 'react';
import { getPaymentOptionsTemplate } from './templates/PaymentViewTemplates';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { useSelector } from 'react-redux';
import CanalPaymentHiddenForm from '../hiddenForms/CanalPaymentHiddenForm';
import { redirectToOrderProcessingPage } from 'common/utilities/utils';
import { PAYMENT_TENDER_TYPES } from 'common/constants/SharedConstants';
import { dispatchPaymentRequest } from '../utils/JapanPaymentUtils';
import ModalComponent from 'molecules/Modal';
import { Helmet } from 'react-helmet';

const JapanPaymentView = props => {
  const { checkoutDetails, updateCheckoutDetails } = props;

  const { paymentsReducer } = useSelector(data => data);

  useEffect(() => {
    checkoutDetails?.isUpdatedOrderActionRequest && updateCheckoutDetails({ dispatchOrderAction: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.isUpdatedOrderActionRequest]);

  useEffect(() => {
    if (checkoutDetails?.tender?.name === PAYMENT_TENDER_TYPES?.PAY_BY_CASH) {
      checkoutDetails?.orderId &&
        checkoutDetails?.isCreateOrderValidateCompleted &&
        redirectToOrderProcessingPage(props);
    } else {
      ((checkoutDetails?.isCreateOrderValidateCompleted &&
        checkoutDetails?.orderId &&
        checkoutDetails?.isClickPlaceOrder &&
        checkoutDetails?.tender?.name === PAYMENT_TENDER_TYPES?.CANAL) ||
        checkoutDetails?.tender?.name === PAYMENT_TENDER_TYPES?.DGFT_CREDIT_CARD) &&
        dispatchPaymentRequest(props);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.isCreateOrderValidateCompleted]);

  useEffect(() => {
    if (checkoutDetails?.paymentProvider) {
      updateCheckoutDetails({
        enableDgftCardPanel: true,
        enablePaymentCardInputPanel: false,
        DgftPaymentId: null,
        DgftTokenApiKey: null,
        DgftresHtml: null,
        DgftModalJs: null,
        DgftModalOpen: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.paymentProvider]);

  useEffect(() => {
    checkoutDetails?.tender?.name !== PAYMENT_TENDER_TYPES?.DGFT_CREDIT_CARD &&
      updateCheckoutDetails({
        enableContinuePayment: false,
        isClickContinuePayment: true,
        placeOrderButtonEnabled: true,
        showPlaceOrderLoading: false,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.isPaymentSelected, checkoutDetails?.tender?.name]);

  useEffect(() => {
    if (checkoutDetails?.tender?.name === PAYMENT_TENDER_TYPES?.DGFT_CREDIT_CARD && checkoutDetails?.DgftModalOpen) {
      const interval = setInterval(() => {
        window?.OnLoadEvent();
      }, 1000);
      return () => clearInterval(interval);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.DgftModalOpen]);

  const modalProps = {
    id: 'DgftModalPopup',
    role: 'dialog',
    modalTitleId: 'DgftModalPopup',
    show: true,
    classNames: 'DgftModalPopup',
    showCloseBtn: true,
    showBackBtn: false,
    autoFocus: true,
  };

  return (
    <>
      <div className='col-sm-8 col-12'>
        <div className='labelContent labelContentAddNewCard'>
          <span>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.SELECT_YOUR_PAYMENT)}</span>
        </div>
      </div>
      {getPaymentOptionsTemplate(checkoutDetails, updateCheckoutDetails)}
      <div className='hidden'>
        {checkoutDetails?.tender?.name === PAYMENT_TENDER_TYPES?.CANAL && (
          <CanalPaymentHiddenForm checkoutDetails={checkoutDetails} data={paymentsReducer} />
        )}
      </div>
      {checkoutDetails?.DgftModalOpen && (
        <ModalComponent {...modalProps}>
          <Helmet>
            <script type='text/javascript'>{checkoutDetails?.DgftModalJs[1]}</script>
          </Helmet>
          <div>
            <div dangerouslySetInnerHTML={{ __html: checkoutDetails?.DgftresHtml }}></div>
          </div>
        </ModalComponent>
      )}
    </>
  );
};

export default JapanPaymentView;
